import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createAppTheme } from "./createAppTheme";
import { ThemeModeContext } from "./ThemeModeContext";
import { getStoredThemeMode, THEME_STORAGE_KEY } from "./themeConfig";

export default function ThemeModeProvider({ children }) {
  const [mode, setModeState] = useState(getStoredThemeMode);

  const setMode = useCallback((next) => {
    setModeState(next);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }, []);

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  useEffect(() => {
    const canvas = theme.palette?.background?.default || "#f3f5f9";
    document.documentElement.style.setProperty("--app-canvas", canvas);
    document.documentElement.style.colorScheme = mode === "dark" ? "dark" : "light";
    document.documentElement.dataset.theme = mode;
  }, [theme, mode]);

  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);

  return (
    <ThemeModeContext.Provider value={value}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        {children}
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
}
